.root {
  display: flex;
  flex-direction: column;
  gap: var(--spacingSm);
}

.change {
  display: flex;
  flex-direction: column;
}
